import React from 'react';
import { Search, TrendingUp } from 'lucide-react';

const SearchAppearancesCard = ({ count = 0, topQueries = [], days = 7 }) => {
  return (
    <div className="bg-white rounded-lg border border-gray-200 p-6">
      <div className="flex items-center gap-3 mb-4">
        <div className="w-10 h-10 rounded-lg bg-green-100 flex items-center justify-center">
          <Search className="w-5 h-5 text-green-600" />
        </div>
        <div className="flex-1">
          <h3 className="font-semibold text-gray-900">Search Appearances</h3>
          <p className="text-sm text-gray-600">Last {days} days</p>
        </div>
        <div className="text-3xl font-bold text-green-600">{count}</div>
      </div>

      {topQueries.length > 0 ? (
        <div className="space-y-2">
          <p className="text-xs font-medium text-gray-700 mb-2">Top Search Queries:</p>
          {topQueries.map((item, index) => (
            <div
              key={index}
              className="flex items-center justify-between p-2 bg-gray-50 rounded-lg"
            >
              <div className="flex items-center gap-2 flex-1 min-w-0">
                <TrendingUp className="w-4 h-4 text-green-600 flex-shrink-0" />
                <span className="text-sm text-gray-900 truncate">{item.query}</span>
              </div>
              <span className="text-xs font-medium text-gray-600 ml-2">
                {item.count}x
              </span>
            </div>
          ))}
        </div>
      ) : (
        <div className="text-center py-8 text-gray-500 text-sm">
          No search appearances in the last {days} days
        </div>
      )}
    </div>
  );
};

export default SearchAppearancesCard;
